import { Route } from 'react-router'
import { observer } from 'mobx-react-lite'
import { RoutesWithNotFound } from 'entities/ExportRouters/ui/RoutesWithNotFound'
import { ApplicationsAccessLayout } from 'pages/settings/pages/developer/pages/applications/layout/ApplicationsAccessLayout'
import { ApplicationsPageLayout } from 'pages/settings/pages/developer/pages/applications/layout/ApplicationsPageLayout'
import { ApplicationsPage } from 'pages/settings/pages/developer/pages/applications/ui/applicationsPage'

export const ApplicationsRouter = observer(() => {
  return (
    <RoutesWithNotFound>
      <Route element={<ApplicationsAccessLayout />}>
        <Route element={<ApplicationsPageLayout />}>
          <Route path={'/'} element={<ApplicationsPage />} />
        </Route>
      </Route>
    </RoutesWithNotFound>
  )
})
